import {IRootState} from "../reducers";

export const getLoadingSpinners = (state: IRootState) =>
  state.spinnerReducer.loadingCount;
